import React from 'react';
import { Box,Typography,Divider } from '@mui/material';
import Question from './Question';
import { useTranslation } from 'react-i18next';
const Section = ({ error,title, sectionIndex, questions, handleRatingChange, ratings,handleTextCombo}) => {
  const { t } = useTranslation();
  return (
    <Box sx={{my:2}}>
        <Typography variant="h4" mb={4}>{t(title)}</Typography>
      {questions.map((question, index) => {
        return(
        <>
          <Question
          key={index}
          index={index}
          question={question.text}
          subtext={question.subtext}
          options={question.options}
          type={question.type}
          handleRatingChange={(questionIndex, option) =>
            handleRatingChange(sectionIndex, questionIndex, option)
          }
          handleTextCombo={handleTextCombo}
          rating={ratings.find(
            (rating) =>
              rating.section === sectionIndex && rating.question === index
          )?.answer}
        />
        {index < questions.length - 1 && <Divider sx={{ my: 2 }} />}
        </>

)})}
      {error !== '' && (
        <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
          {t(error)}
        </Typography>
      )}
    </Box>
  );
};

export default Section;